import { Link } from 'react-router-dom';

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1.5 text-xs text-foreground-600">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={`${item.label}-${index}`} className="flex items-center gap-1.5">
            {item.to && !isLast ? (
              <Link to={item.to} className="whitespace-nowrap transition-colors hover:text-primary-700">
                {item.label}
              </Link>
            ) : (
              <span className="whitespace-nowrap text-foreground-800" aria-current={isLast ? 'page' : undefined}>
                {item.label}
              </span>
            )}
            {!isLast && (
              <span className="flex h-3 w-3 items-center justify-center text-foreground-400">
                <i className="ri-arrow-right-s-line" aria-hidden="true" />
              </span>
            )}
          </span>
        );
      })}
    </nav>
  );
}